import { useEffect, useMemo } from 'react';

import { LocalStore } from 'constants/localstore';
import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import {
  setTableState,
  setTableSort,
  setTableSearchFilter,
  PROJECT_TABLES_STATE,
  PROJECT_TABLES_SEARCH,
  PROJECT_TABLES_SORT,
} from 'components/app/projects/_mediator/projects.slice';
import { ProjectLocalstore } from 'components/app/_mediator/localstore/hooks/use-project';
import { setView } from 'components/app/storyboard/_mediator/sb.slice';

export const useAppRestoreView = () => {
  const appRestored = useAppSelector((state) => state.app.appRestored);
  const dispatch = useAppDispatch();

  const data = useMemo(() => {
    const json = localStorage.getItem(LocalStore.project);
    if (json) return JSON.parse(json) as ProjectLocalstore;
  }, []);

  useEffect(() => {
    if (!appRestored || !data) return;
    PROJECT_TABLES_SEARCH.forEach((key) => dispatch(setTableSearchFilter({ key, value: data[key] })));
    PROJECT_TABLES_STATE.forEach((key) => dispatch(setTableState({ key, value: data[key] })));
    PROJECT_TABLES_SORT.forEach((key) => dispatch(setTableSort({ key, value: data[key] })));
    dispatch(setView(data.sbViewMode));
  }, [appRestored]);
};
